import Utility from "../../helpers/paymentHelpers/utility";
import LocalStorageFunc from "../../helpers/paymentHelpers/localStorageFunc";
import ApiKeys from "../apiKeys";
import {
  MINIAPP,
  ORDER_TYPE,
  PAYMENT_HEADER_VARIENT,
} from "../../helpers/paymentHelpers/paymentConstants";
import { EndPoints } from "../apiEndpoints";

const getTimePrefixWith = (userId) => `${new Date().getTime()}-${userId}`;

const getLandingPageVWOCombinedTest = () =>
  JSON.stringify({
    ...Utility.getVwoPwaV2Variations(),
    VWO_HOME_VARIANT: Utility.getLandingPageVWOTest(),
    OrderHistoryFlow: Utility.getOrderHistroyVariant(),
    tip_exp: Utility.getTipCartVariant(),
    vwo_next_gen_payment_varient: PAYMENT_HEADER_VARIENT,
  });

const headers = (payload) => {
  let isMiniApp = Utility.getMiniAppStorageVal();
  isMiniApp = [MINIAPP.GPAY, MINIAPP.PAYTM].includes(isMiniApp) && isMiniApp;
  const apiKey = isMiniApp
    ? EndPoints.envConfig[`${isMiniApp}_API_KEY`]
    : EndPoints.envConfig.API_KEY;
  const clientType = isMiniApp
    ? EndPoints.envConfig[`${isMiniApp}_CLIENT_TYPE`]
    : EndPoints.envConfig.CLIENT_TYPE;
  const userDataHeaders = LocalStorageFunc.getUserData().headers;
  const storeId = LocalStorageFunc.storeId();
  const getMaxAge = () => new Date(Date.now() + 31556952000).getTime();

  let headers = {
    // 'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": "*",
    api_key: ApiKeys.CATALOG_MENU_API_KEY,
    // api_key: apiKey,
    authToken:
      userDataHeaders?.credentials?.accessToken ||
      userDataHeaders?.credentials?.accessKeyId,
    userId: userDataHeaders?.userId || "",
    storeId,
    cartid: userDataHeaders?.cartId || "",
    isLoggedIn: userDataHeaders?.isLoggedIn || "",
    client_type: clientType,
    source: userDataHeaders?.source || "PWA18",
    isNxgCart: true,
    // 'X-FORWARDED-FOR-requestId': getTimePrefixWith(userDataHeaders?.userId),
    deliveryType: userDataHeaders?.deliveryType || ORDER_TYPE.DELIVERY,
    // 'X-Frame-Options': 'mitigate',
    // 'X-content-Type-options': 'nosniff',
    // 'Strict-Transport-Security': `max-age=${getMaxAge()}`,
    ab_test_variant: getLandingPageVWOCombinedTest(),
  };

  if (
    userDataHeaders?.credentials &&
    Object.keys(userDataHeaders?.credentials).length &&
    userDataHeaders?.credentials?.sessionToken
  ) {
    headers.sessiontoken = userDataHeaders.credentials.sessionToken;
  }

  if (payload && payload.withRefreshToken) {
    headers["refreshtoken"] = userDataHeaders?.credentials?.refreshToken || "";
  }
  if (payload && payload.mid) {
    headers["mid"] = "oms_merchant_id_1";
  }
  if (payload && payload.xTenantID) {
    headers["X-TenantID"] = "dominos_IN";
  }
  if (payload && payload.utm_source) {
    headers["utm_source"] = payload.utm_source;
  }
  if (payload && payload.gps_enabled) {
    headers["gps_enabled"] = payload.gps_enabled;
  }
  if (payload && payload.checksum) {
    headers["checksum"] = payload.checksum;
  }

  return headers;
};

export default headers;
